module.exports = __webpack_public_path__ + "img/30YearsFront.b6a59e1c.png";